import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'shared/components/shared/header/header.component';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EMediaBreakpoint } from 'projects/shared/lib/enum/media/media-breakpoint.enum';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { ICartCreationDialogService } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-service.abstract';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Subscription } from 'rxjs';
import { ContextMHService, IContextMHServiceToken } from '../../../services/infrastructure/context.service';
import { IMediaService, IMediaServiceToken } from 'shared/services/ui/media/media-service.interface';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SearchPreviewItemComponent } from 'shared/components/shared/search-preview-item/search-preview-item.component';
import { DirectivesModule } from 'shared/directives/directives.module';
import { UsernameAbbreviationPipe } from 'shared/pipes/username-abbreviation/username-abbreviation.pipe';
import { CategoryNavBarMHModule } from '../category/nav-bar/category-nav-bar.module';
import { MyShopToggleButtonModule } from '../my-shop/toggle-button/my-shop-toggle-button.module';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CategoryNavBarMHModule,
    MyShopToggleButtonModule,
    DirectivesModule,
    SearchPreviewItemComponent,
    UsernameAbbreviationPipe,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderMHComponent extends HeaderComponent implements OnInit, OnDestroy {

  private readonly contextService: ContextMHService = inject(IContextMHServiceToken);
  private readonly mediaService: IMediaService = inject(IMediaServiceToken);

  private contextSubscription: Subscription | undefined;
  private mediaSubscription: Subscription | undefined;

  public mobileNavMenuCollapseShow: boolean | undefined;

  constructor() {
    super();

    this.contextService = inject(IContextMHServiceToken);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.contextSubscriptionInit();
    this.mediaSubscriptionInit();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();

    this.contextSubscription?.unsubscribe();
    this.mediaSubscription?.unsubscribe();
  }

  private contextSubscriptionInit() {
    if (!this.contextSubscription) {
      this.contextSubscription =
        this.contextService.contextChangeGet().subscribe(
          () => {
            this.updateSearchPreviewAsync(this.searchText);
          }
        );
    }
  }

  private mediaSubscriptionInit() {
    if (!this.mediaSubscription) {
      this.mediaSubscription = this.mediaService.mediaBreakpointChangeGet().subscribe(
        (media) => {
          if (media >= EMediaBreakpoint.XXL) {
            this.mobileNavMenuCollapseShow = false;
          }
        }
      );
    }
  }

  public shopContextToggle() {
    this.contextService.contextToggle();
  }

  public createCartDialogShow() {
    ServiceLocator.injector.get(ICartCreationDialogService).cartCreationDialogShow(
      () => { },
    );
  }

  public logout() {
    this.userService.userLogout().subscribe({
      next: () => {
        this.authService.accessJWTClear();

        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@NavTopMenuLogoutSuccessToastTitle:Logout successful`,
        }));

        this.router.navigate([this.anonymousLandingPage.routerlink], { queryParams: this.anonymousLandingPage.queryParams });
      },
      error: (error) => {
        this.logger.error(error, this.constructor.name);
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Danger,
          title: $localize`:@@NavTopMenuLogoutErrorToastTitle:Logout failed`,
          code: JSON.parse(error.response).errorCode
        }));
      },
      complete: () => { }
    });
  }

}
